import { ca } from '@cian/analytics';

import { MOBILE_APP_BANNER_TITLE } from './constants';

export function trackMobileAppBannerClick() {
  ca('eventSite', {
    action: 'click',
    category: 'dailyrent_banner',
    label: 'install_app',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'install_app',
        bannerName: MOBILE_APP_BANNER_TITLE,
      },
    },
  });
}

export function trackMobileAppBannerShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'dailyrent_banner',
    label: 'install_app',
    name: 'oldevent',
    page: {
      extra: {
        trap_type: 'install_app',
        bannerName: MOBILE_APP_BANNER_TITLE,
      },
    },
  });
}
